import { Controller } from "@hotwired/stimulus"

// Like the shared import-channel controller, but stays on the page and shows the completion
// partial in place instead of reloading - Contacts' completion partial has its own
// "Back to Contacts"/"Import More" actions meant to be seen, not immediately discarded.
export default class extends Controller {
  static get targets() {
    return ["errorContainer", "completeContainer", "form", "importTable"];
  }

  handleError(errorText) {
    $(this.errorContainerTarget).text(errorText);
  }

  handleExternalImport(event) {
    const json = event.detail;
    if (json.status !== "ok") {
      this.handleError(json.error);
      return;
    }
    this.beginStream(json.importId, json.channelName);
  }

  beginStream(importId, channelName) {
    if (this.hasFormTarget) { $(this.formTarget).addClass("hidden"); }
    $(this.importTableTarget).removeClass("hidden");

    const controller = this;
    const subscription = App.cable.subscriptions.create({ channel: channelName, id: importId }, {
      received(data) {
        if (data.event === "import") {
          $(controller.importTableTarget).append(data.html);
        } else {
          $(controller.importTableTarget).addClass("hidden");
          $(controller.completeContainerTarget).append(data.html);
          subscription.unsubscribe();
        }
      }
    });
  }
}
